import * as React from 'react'

export const useIsSticking = (element: HTMLElement | null, offset = 0) => {
  const [isStuck, setIsStuck] = React.useState(true)

  React.useEffect(() => {
    if (!element) {
      return
    }

    const handleScroll = () => {
      const { bottom, height } = element.getBoundingClientRect()
      const viewportHeight = window.innerHeight

      setIsStuck(bottom + height + offset < viewportHeight)
    }

    window.addEventListener('scroll', handleScroll)
    handleScroll()

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [element, offset, setIsStuck])

  return isStuck
}
